import React from "react";

const ImportExport = ({ handleExportChoices, handleImportChoices }) => (
  <div className="border mt-3">
    <div className="d-flex flex-wrap">
      <div className="mb-3 me-3">
        <label>Import Choices:</label>
        <input
          type="file"
          className="form-control"
          accept=".json"
          onChange={handleImportChoices}
        />
      </div>
    </div>
    <button className="btn btn-secondary mb-3" onClick={handleExportChoices}>
      Export Choices
    </button>
  </div>
);

export default ImportExport;
